import {createDraftSafeSelector} from '@reduxjs/toolkit';

import themeStyle from '../../consts/themeStyle';

const selectGlobalState = (state) => state?.global;

export const selectBackRoute = createDraftSafeSelector(selectGlobalState, (state) => state.backRoute);

export const selectActiveRoute = createDraftSafeSelector(selectGlobalState, (state) => state.activeRoute);

export const selectIsDarkMode = createDraftSafeSelector(selectGlobalState, (state) => state.theme === themeStyle.DARK);

export const selectNotifications = createDraftSafeSelector(selectGlobalState, (state) => state.notifications || []);
